// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog-module--blog--23ORV","tag-list":"Blog-module--tag-list--3MZN1","active":"Blog-module--active--3Kp4c","blog__posts":"Blog-module--blog__posts--3rw2T"};